<template> 
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3"> 
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('update_bank_account') }}</h1>  
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li> 
                    <li class="breadcrumb-item text-primary">{{ $t('accounts') }}</li>     
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'BankList' }">{{ $t('bank') }}</router-link></li>     
                    <li class="breadcrumb-item text-gray-600">{{ $t('update_bank_account') }}
                        <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li> 
                </ul> 
            </div>  
            <div class="d-flex align-items-center py-1">
                <router-link to="/BankList">
                    <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> {{ $t('return_back_to_list') }}</span>
                    </button>
                </router-link> 
                &nbsp;
                <div class="dropdown" v-if="this.$isCredentialActive(13,'D')">
                    <button class="btn btn-light-info border border-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" id="bankActions" type="button">
                    <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                    <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                    </svg></span>
                        {{ $t('actions') }}
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="bankActions"> 
                        <li>
                            <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteItem()">
                                <span class="svg-icon svg-icon-muted svg-icon-2 text-danger"><svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"/>
                                    <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                                    <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                                    </svg>
                                </span>
                                {{ $t('delete') }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div> 
        <div class="content flex-row-fluid mt-4" id="kt_content"> 
            <StatsBar :form-account="this.form"></StatsBar>  
            <div class="card-body">
                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Account'}" data-bs-toggle="tab" href="#kt_accounting_1" target="_self"
                        @click="this.activeTab = 'Account'">
                            <h4> {{ $t('bank_account') }} </h4>
                        </a>
                    </li>
                    <li class="nav-item" v-if="this.$isModuleActive(3)">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Documents'}" data-bs-toggle="tab" href="#kt_accounting_4" target="_self"
                        @click="activateDocumentsSection()">
                            <h4> {{ $t('documents') }} </h4>
                        </a>
                    </li>
                    <li class="nav-item" v-if="this.$isModuleActive(3)">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Parameters'}" data-bs-toggle="tab" href="#kt_accounting_5" target="_self"
                        @click="activateParametersSection()">
                            <h4> {{ $t('transfer_parameters') }} </h4>
                        </a>
                    </li>
                </ul>
            </div>
            <RequiredField></RequiredField>
            <div class="tab-content" id="myTabContent">
                <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel">
                    <form id="poliform" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                        <div class="row p-10">
                                <div class="d-flex flex-row row">
                                    <div class="d-flex flex-column flex-row-auto col-lg-6">
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0" style="border-radius: 0.95rem; height: 286px;"> 
                                                    <div class="fv-row mb-7 row">
                                                        <div class="col-lg-12" v-if="isViewAccountId">
                                                        <label class="fs-6 fw-bold form-label mt-3" :class="{'required': isViewAccountId}">
                                                            {{ $t('account_id') }}
                                                        </label>
                                                        <input type="text" class="form-control" name="accountID" v-model="form.account_id">
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'name'">{{ $t('name') }}</label>
                                                            <input type="text" class="form-control" name="name" v-model="form.name" v-custom>
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'account_type'">{{ $t('account_type') }}
                                                            </label>
                                                            <Select2 v-model="form.account_type_id" :options="accountTypeList" name="account_type" v-custom :settings="{ width: '100%'}"/> 
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'currency'">
                                                                <span>{{ $t('currency') }}</span>
                                                            </label>
                                                            <Select2 v-model="form.currency" :options="currencyList" name="currency" v-custom :settings="{ width: '100%'}"/> 
                                                        </div>
                                                    </div> 
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column flex-row-auto col-lg-6">
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-8 row">
                                                        <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'bank_account_detail'">
                                                            <span>{{ $t('bank_account_detail') }}</span>
                                                        </label>
                                                        <Select2 v-model="form.bank_detail_id" :options="bankDetailList" name="bank_account_detail" v-custom :settings="{ width: '100%'}"/> 
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'branch'">
                                                            <span>{{ $t('branch') }}</span>
                                                        </label>
                                                        <Select2 v-model="form.branch_id" :options="branchList" name="branch" v-custom :settings="{ width: '100%'}"/> 
                                                    </div>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                <div class="fv-row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'general_bank_list'">{{ $t('general_bank_list') }}
                                                        </label>
                                                        <Select2 v-model="form.bank_bank_id" :options="bankList" @select="onGetTemplateList()" name="general_bank_list" v-custom :settings="{ width: '100%'}"/> 
                                                    </div>
                                                </div>                                               
                                                <div class="fv-row row mb-7">
                                                    <div class="col-lg-6">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'short_code'">{{ $t('short_code') }}</label>
                                                        <input type="text" class="form-control" name="short_code" v-model="form.bank_short_code" v-custom>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'account_number'">{{ $t('account_number') }}</label>
                                                        <input type="text" class="form-control" name="account_number" v-model="form.account_number" v-custom>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'IBAN'">{{ $t('iban') }}</label>
                                                        <input type="text"  :class="{'is-invalid':ibanError}" :maxlength="maxLength" class="form-control" @input="validateIban()" name="iban" v-model="form.iban" v-custom>
                                                        <p v-if="ibanError" class="error-message">{{ ibanError }}</p>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'dll_template_id'">
                                                            <span>{{ $t('data_import_template') }}</span>
                                                            <small v-if="form.bank_bank_id == '-1' || form.bank_bank_id == '' || form.bank_bank_id == null || form.bank_bank_id == undefined" class="ms-3 text-danger">
                                                                {{ $t('please_select_a_bank') }}
                                                            </small>
                                                        </label>
                                                        <div class="input-group mb-3">
                                                            <div class="form-control border-0 m-0 p-0">
                                                                <DxSelectBox
                                                                :data-source="groupedTemplates"
                                                                display-expr="name"
                                                                value-expr="id"
                                                                grouped="true"
                                                                v-model="form.dll_template_id"
                                                                styling-mode="outlined"
                                                                width="100%"
                                                                />
                                                            </div>
                                                            <button class="btn btn-primary btn-sm py-0" v-if="!isCompanyTemplateSelected"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#kt_modal_add_data_import_template" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" 
                                                                @click="onOpenAddModal()">
                                                                <i class="fa fa-plus"></i> 
                                                                {{ $t('add') }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12" v-if="isCompanyTemplateSelected">
                                                        <button class="btn btn-xs btn-primary btn-sm me-1"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#kt_modal_add_data_import_template" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" 
                                                            @click="onOpenAddModal()">
                                                            <i class="fa fa-plus"></i> 
                                                            {{ $t('add_new') }}
                                                        </button>
                                                        <button class="btn btn-xs btn-success btn-sm me-1"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#kt_modal_desinger_data_import_template" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                                            @click="onOpenDesignerModal()">
                                                            <i class="fa fa-brush"></i> 
                                                                {{ $t('design') }}
                                                        </button>
                                                        <button class="btn btn-xs btn-info btn-sm me-1"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#kt_modal_edit_data_import_template" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" 
                                                            @click="getTemplateData()">
                                                            <i class="fa fa-edit"></i> 
                                                                {{ $t('edit') }}
                                                        </button>
                                                        <button class="btn btn-xs btn-warning btn-sm me-1"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#kt_modal_parameters_data_import_template" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                                            @click="onOpenParametersModal()">
                                                            <i class="fa fa-pen"></i> 
                                                                {{ $t('parameters') }}
                                                        </button>
                                                        <button class="btn btn-xs btn-danger btn-sm me-1" 
                                                            @click="onDeleteDesign()">
                                                            <i class="fa fa-trash"></i> 
                                                                {{ $t('delete') }}
                                                        </button>
                                                    </div>
                                                </div> 
                                            </div>
                                            <div class="card-footer p-3" v-if="isShowWarning">
                                                <i class="bi bi-info-circle text-danger me-1"></i>
                                                <span class="text-danger"> 
                                                    {{ $t('the_data_import_template') }} 
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="col-lg-6" v-if="form.account_type_id == '2'">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-7 row">
                                                        <div class="col-lg-8">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'credit_card_no'">
                                                                <span> {{ $t('credit_card_no') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="credit_card_no" v-model="form.credit_card_no" v-custom>
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'cvv'">
                                                                <span> {{ $t('cvv') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="cvv" v-model="form.cvv" v-custom>
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'credit_card_name'">
                                                                <span> {{ $t('name') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="credit_card_name" v-model="form.cardholder_name" v-custom>
                                                        </div>
                                                    </div> 
                                            </div>
                                        </div>                    
                                    </div>
                                    <div class="col-lg-6" v-if="form.account_type_id == '2'">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-7 row">
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'valid_date'">
                                                                <span> {{ $t('valid_date') }} </span>
                                                            </label>
                                                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.period_start" inputClassName="form-control" format="dd.MM.yyyy HH:mm" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>  
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'expiry_date'">
                                                                <span> {{ $t('expiry_date') }} </span>
                                                            </label>
                                                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.period_start" inputClassName="form-control" format="dd.MM.yyyy HH:mm" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>  
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>                    
                                    </div>

                                    <div class="col-lg-6" v-if="form.account_type_id == '3'">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-7 row">
                                                        <div class="col-lg-6">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('loan_amount') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="company_name" v-model="form.loan_amount">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('loan_rate') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="company_name" v-model="form.loan_rate">
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('loan_term') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="company_name" v-model="form.loan_term">
                                                        </div>
                                                    </div> 
                                            </div>
                                        </div>                    
                                    </div>
                                    <div class="col-lg-6" v-if="form.account_type_id == '3'">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-7 row">
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('total_refund') }} </span>  <small>  {{ $t('toplam_geri_deme') }}  </small>
                                                            </label>
                                                            <input type="number" class="form-control" name="company_name" v-model="form.loan_total_refund">
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('monthly_payment_amount') }}  </span> <small>  {{ $t('aylk_deme_tutar') }}  </small>
                                                            </label>
                                                            <input type="number" class="form-control" name="company_name" v-model="form.loan_monthly_payment_amount">
                                                        </div>
                                                    </div> 
                                            </div>
                                        </div>                    
                                    </div>

                                    <div class="col-lg-6" v-if="form.account_type_id == '4'">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-7 row">
                                                        <div class="col-lg-6">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('lease_amount') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="company_name" v-model="form.lease_amount">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('lease_rate') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="company_name" v-model="form.lease_rate">
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('lease_term') }} </span>
                                                            </label>
                                                            <input type="text" class="form-control" name="company_name" v-model="form.lease_term">
                                                        </div>
                                                    </div> 
                                            </div>
                                        </div>                    
                                    </div>
                                    <div class="col-lg-6" v-if="form.account_type_id == '4'">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-7 row">
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('total_refund') }} </span>  <small>  {{ $t('toplam_geri_deme') }}  </small>
                                                            </label>
                                                            <input type="number" class="form-control" name="company_name" v-model="form.lease_total_refund">
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3">
                                                                <span> {{ $t('monthly_payment_amount') }}  </span> <small>  {{ $t('aylk_deme_tutar') }}  </small>
                                                            </label>
                                                            <input type="number" class="form-control" name="company_name" v-model="form.lease_monthly_payment_amount">
                                                        </div>
                                                    </div> 
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="col-lg-12">
                                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body pb-0"> 
                                                    <div class="fv-row mb-7">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'notes'">
                                                            <span>{{ $t('notes') }}</span>
                                                        </label>
                                                        <textarea class="form-control" name="notes" v-model="form.notes" v-custom></textarea>
                                                    </div> 
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mt-0" v-if="this.$isCredentialActive(13,'U')">
                                        <div class="d-grid gap-2"> 
                                            <button type="button" :disabled="this.ibanErrorControl" class="btn btn-lg btn-primary mb-0" @click="this.saveData()" data-kt-indicator="on">
                                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                                </svg>
                                                </span> 
                                                <strong v-if="!this.isProgressing"> {{ $t('update_bank_account') }} </strong> 
                                                    <span class="indicator-progress" v-if="this.isProgressing">
                                                        {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                    </span> 
                                            </button>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </form>
                </div>
                <div class="card card-xxl-stretch tab-pane fade" id="kt_accounting_4" role="tabpanel">
                    <div class="row p-10" v-if="this.activeTab == 'Documents'">
                        <FileManager :location="1" :locationtype="4" :upload_source="4" ref="FileManagerComponent"></FileManager>
                    </div>
                </div>
                <div class="card card-xxl-stretch tab-pane fade" id="kt_accounting_5" role="tabpanel">
                    <div class="row" v-if="this.activeTab == 'Parameters'">
                        <AccountTransferParameters :bank-account="1" ref="AccountTransferParameters"></AccountTransferParameters>
                    </div>
                </div>
            </div>
        </div>

        <!-- DATA IMPORT MODAL -->
        <div class="modal fade" id="kt_modal_add_data_import_template" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content"  >
                    <div class="modal-header bg-primary" id="kt_modal_add_user_header">
                        <h2 class="modal-title text-white fw-bolder col-md-10">
                             {{ $t('add_template') }} 
                        </h2>  
                        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeDataImportModal">
                            <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                        transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                        transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="row">
                                <div class="col-lg-12">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                         {{ $t('name') }} 
                                    </label>
                                    <input type="text" class="form-control" placeholder="" name="name"
                                        v-model="modalForm.name">
                                </div>
                                <div class="col-lg-12">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                         {{ $t('file_type') }} 
                                    </label>
                                    <Select2 v-model="modalForm.file_type_id" :options="fileTypeList" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_data_import_template .modal-content' }" />
                                </div>
                                <div class="fv-row">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                     {{ $t('description') }} 
                                    </label>
                                    <textarea class="form-control" name="description" v-model="modalForm.description"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-12 mt-7">
                                <div class="d-grid gap-2">
                                    <button type="button" class="btn btn-lg btn-success " @click="this.onSaveTemplate()" data-kt-indicator="on">
                                        <span class="svg-icon svg-icon-2">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                            <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                            </svg>
                                        </span>
                                        <strong v-if="!this.isProgressing">  {{ $t('save_template') }} </strong>
                                        <span class="indicator-progress" v-if="this.isProgressing">  {{ $t('saving_template') }}  <span
                                                class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal fade" id="kt_modal_edit_data_import_template" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog  modal-fullscreen">
                <div class="modal-content"  >
                    <div class="modal-header bg-primary">
                        <h2 class="modal-title text-white fw-bolder col-md-10">
                             {{ $t('edit_template') }} 
                        </h2>  
                        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" :aria-label="$t('close')" ref="closeDataImportEditModal"                
                            @click="this.isShow.EditModal = false;">
                            <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                        transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                        transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-12 mt-0">
                                <div class="d-flex flex-row row">
                                    <div class="d-flex flex-column flex-row-auto col-lg-6">
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-gray-300">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                             {{ $t('name') }} 
                                                        </label>
                                                        <input type="text" class="form-control" placeholder="" name="name" v-model="editForm.name">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                             {{ $t('file_type') }} 
                                                        </label>
                                                        <Select2 v-model="editForm.file_type_id" :options="fileSourceTypeList" :settings="{ width: '100%', dropdownParent: '#kt_modal_edit_data_import_template .modal-content' }" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column flex-row-auto col-lg-6">
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-gray-300">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="fv-row">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                         {{ $t('description') }} 
                                                        </label>
                                                        <textarea rows="5" class="form-control" name="description" v-model="editForm.description"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                            <div class="col-lg-12 text-start">
                                <button class="btn btn-primary w-100 mt-4" @click="this.onUpdateTemplate()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"/>
                                        <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"/>
                                    </svg>
                                 {{ $t('update') }} 
                                </button>
                            </div>
                        </div>

                        <div class="col-lg-12 mt-7" > 
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="kt_tab_pane_excel" role="tabpanel">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                         {{ $t('upload_excel_file') }} 
                                    </label>
                                    <input type="file" id="input" class="form-control form-control-lg input-lg" @change="onFileChange" ref="excelFile"/>
                                </div>                             
                            </div> 
                            <div class="table-responsive mt-7" v-if="this.sheetNames.length > 0">
                                <table class="table table-rounded table-striped border gy-2 gs-2 table-hover mb-0">
                                    <thead>
                                        <tr class="fw-semibold fs-6 text-gray-800 border-bottom border-gray-300">
                                            <th><strong> {{ $t('worksheet_name') }} </strong></th>
                                            <th> {{ $t('description') }} </th>
                                            <th class="text-center"> {{ $t('actions') }} </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in this.sheetNames" v-bind:key="item">
                                            <td class="align-middle fw-bold">
                                                <strong> {{ item.name }} </strong>  
                                            </td>
                                            <td class="align-middle">
                                                <input type="text" class="form-control form-control-sm" v-model="item.description" :disabled="item.is_disabled">
                                            </td> 
                                            <td class="text-center align-middle">
                                                <button type="button" class="btn btn-sm btn-primary p-1 px-3" @click="this.onAddWorksheet(item)" :disabled="item.is_disabled">
                                                    <i class="fa fa-plus"></i>  {{ $t('add') }} 
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="separator border-2 my-10" v-if="sheetNames.length > 0"></div>
                            <div class="table-responsive min-h-300px mt-5" v-if="worksheets.length > 0">
                                <table class="table table-light table-rounded table-striped border border-gray-300 gy-2 gs-2 table-hover mb-0">
                                    <thead>
                                        <tr class="fw-semibold fs-6 text-gray-800 border-bottom border-gray-300">
                                            <th> {{ $t('order') }} </th>
                                            <th> {{ $t('worksheet_name') }} </th>
                                            <th> {{ $t('virtual_name') }} </th>
                                            <th> {{ $t('description') }} </th>
                                            <th class="text-center"> {{ $t('actions') }} </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in this.worksheets" v-bind:key="item">
                                            <td class="text-gray-900 align-middle fw-bolder">
                                                <div class="position-relative d-flex align-items-center">
                                                    <button type="button" class="btn btn-xs btn-secondary" @click="onUpdateOrder(item, 'minus')">
                                                        <i class="bi bi-dash fs-5"></i>
                                                    </button>
                                                    <CurrencyInput type="text" class="border-0 text-center px-0 fw-bold w-50px" 
                                                        :precision="0" v-model="item.column_order" @focus="$event.target.select()" :min="0" @blur="onUpdateOrder(item)"/>
                                                    <button type="button" class="btn btn-xs btn-secondary" @click="onUpdateOrder(item, 'plus')">
                                                        <i class="bi bi-plus fs-5"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="align-middle fw-bold">
                                                <strong> {{ item.name }} </strong>  
                                            </td>
                                            <td class="align-middle fw-bold">
                                               {{ item.virtual_name }}
                                            </td>
                                            <td class="align-middle">
                                                {{item.description}}
                                            </td> 
                                            <td class="text-center align-middle">
                                                <a class="btn btn-danger btn-sm p-1 px-3 cursor-pointer" 
                                                    @click="this.onRemoveWorksheet(item, index)">
                                                    <i class="fa fa fa-times"></i> 
                                                     {{ $t('remove') }} 
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Parameters Modal -->
        <div class="modal fade" id="kt_modal_parameters_data_import_template" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true"
            v-show="isShow.ParameterModal" :class="{'show': isShow.ParameterModal, 'd-none': !isShow.ParameterModal}" style="display: block;">
            <DataImportParametersModal 
                ref="DataImportParametersModal"
            ></DataImportParametersModal>
        </div> 

        <!-- Design Modal -->
        <div class="modal fade" id="kt_modal_desinger_data_import_template" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true"
            v-show="isShow.DesignerModal" :class="{'show': isShow.DesignerModal, 'd-none': !isShow.DesignerModal}" style="display: block;">
            <DataImportDesignerModal 
                ref="DataImportDesingerModal"
            ></DataImportDesignerModal>
        </div> 
    </div>
</template>

<script>
import axios from "axios"; 

import AccountTransferParameters from '../Modals/AccountTransferParameters.vue';
import DataImportDesignerModal from '../Modals/DataImportDesignerModal.vue';
import DataImportParametersModal from '../Modals/DataImportParametersModal.vue';
import { DxSelectBox } from 'devextreme-vue/select-box';

export default {
    name: "BankUpdate",
    components:{
        AccountTransferParameters, DataImportDesignerModal, DataImportParametersModal, DxSelectBox
    },
    data() {
        return {
            userData: this.$getUser(),
            currencyList: [],
            bankList: [],
            accountTypeList: [],
            bankAccountTypeList: [],
            branchList: [],
            isProgressing: false,
            bankDetailList: [],
            form: {
                id: null,
                name: null,
                company_id: null,
                account_type: null,
                account_id: null,
                qr_code: null,
                notes: null,
                account_number: null,
                account_type_id: '1',
                bank_account_type_id: null,
                bank_bank_id: null,
                currency: null,
                bank_short_code: null,
                branch_id: '-1',
                accounting_plan: null,
                bank_detail_id: '-1',
                iban: null,
                dll_template_id: null,
            },
            ibanError: null,
            ibanData: {
                AL: 28, AD: 24, AT: 20, AZ: 28, BH: 22, BE: 16, BA: 20, BR: 29, BG: 22,
                CR: 21, HR: 21, CY: 28, CZ: 24, DK: 18, DO: 28, EE: 20, FO: 18, FI: 18,
                FR: 27, GE: 22, DE: 22, GI: 23, GR: 27, GL: 18, GT: 28, HU: 28, IS: 26,
                IE: 22, IL: 23, IT: 27, JO: 30, KZ: 20, KW: 30, LV: 21, LB: 28, LI: 21,
                LT: 20, LU: 20, MT: 31, MR: 27, MU: 30, MC: 27, MD: 24, ME: 22, NL: 18,
                NO: 15, PK: 24, PS: 29, PL: 28, PT: 25, RO: 24, SM: 27, SA: 24, RS: 22,
                SK: 24, SI: 19, ES: 24, SE: 24, CH: 21, TN: 24, TR: 26, AE: 23, GB: 22,
                VG: 24,
            },
            ibanErrorControl:false,
            test: {
                test1: null
            },
            isViewAccountId: false,
            activeTab: 'Account',
            menuSelection: '/BankHelppage',
            iconView : false,
            maxLength:null,
            dllTemplates:[],
            fileTypeList: [
                { id: 0, text: this.$t('select_an_option') },
                { id: 1, text: this.$t('excel_file_xlsx') },
                { id: 4, text: this.$t('excel_file_xls') },
                { id: 3, text: this.$t('csv_file') },                
            ], 
            templateList:[],
            modalForm:{
                name: null,
                description: null,
                file_type_id: 0
            },
            sheetNames: [],
            showModal:null,
            isShowWarning: false,
            isListProgressing: false,
            isShow: {
                EditModal: false,
                DesignerModal: false,
                ParameterModal: false
            },
            editForm: { 
                category_id: 6,
                source: 1,
                clone_template: 0,
                description: null,
                file_type_id: 0
            },
            fileSourceTypeList: [
                { id: 1, text: this.$t('excel_file_xlsx') },
                { id: 4, text: this.$t('excel_file_xls') },
                { id: 3, text: this.$t('csv_file') },
            ],
            worksheets: []
        };
    },
    computed: {
        groupedTemplates() {
            return [
                {
                    key: 'Default Templates',
                    items: this.dllTemplates.filter(i => i.is_company === 0 || i.id == null)
                },
                {
                    key: 'Company Templates',
                    items: this.dllTemplates.filter(i => i.is_company === 1)
                }
            ]
        },
        isCompanyTemplateSelected() {
            const selectedItem = this.dllTemplates.find(item => item.id === this.form.dll_template_id);
            return selectedItem?.is_company === 1;
        }
    },
    methods: {
        getData() {
            this.bankDetailList = [];
            this.$Progress.start();
            const params = {
                id: this.$getSessionStorage('record_id'),
                session_id: this.$getUser().session_id
            };
            axios.post('api/CompanyAccounts/GetAccountById', params, {'Content-Type': 'application/json'})
            .then((response) => {
                this.form.id = response.data.id; 
                this.form.name = this.$unlock(response.data.name);
                this.form.account_type = response.data.account_type;
                this.form.account_id = this.$unlock(response.data.account_id);
                if(this.form.account_id == '' || this.form.account_id == null || this.form.account_id == undefined) this.form.account_id = '-1';
                this.form.qr_code = this.$unlock(response.data.qr_code);
                this.form.notes = response.data.notes;
                this.form.bank_short_code = this.$unlock(response.data.bank_short_code);
                this.form.currency = (response.data.bank_currency == '' || response.data.bank_currency == null) ? '-1': response.data.bank_currency;
                this.form.bank_bank_id = (response.data.bank_bank_id == '' || response.data.bank_bank_id == null) ? '-1': response.data.bank_bank_id;  
                this.form.account_type_id = response.data.bank_account_type_id; 
                this.form.account_number = this.$unlock(response.data.bank_account_number);
                this.form.branch_id = (response.data.branch_id == '' || response.data.branch_id == null) ? '-1' : response.data.branch_id;
                this.form.bank_detail_id = (response.data.bank_detail_id == '' || response.data.bank_detail_id == null) ? '-1' : response.data.bank_detail_id;
                this.form.iban = this.$unlock(response.data.bank_iban);
                this.form.dll_template_id = response.data.bank_dll_template_id;
                this.getLists();
            })
            .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_getplease_refresh_the_page_and_try_again')
            );
            });
        },
        getLists() {
            this.bankAccountTypeList = [];
            this.bankList = [];

            const parameters = {
                session_id: this.$getUser().session_id,
                list_types: [
                    {
                        list_type: 2,
                        list_name: "bank_list"
                    }
                ],
                list_name: ["branch", "account_setting", "currency"],
                account_type: 4 // yalnızca account settings listesi çekilecek ise gerekli
            };
            const parameters2 = {
                session_id: this.$getUser().session_id,
                list_type: 1, // Bank Detail List: 1
                list_name: ["bank_detail_list"],
                get_access_status: 0,
                tip: 9
            };
            const parameters3 = {
                session_id : this.$getUser().session_id,
                category: 0,
                module_type: 2,
                related_account_id: this.form.bank_bank_id == '-1' ? null : this.form.bank_bank_id
            };
            const requestOne =  axios.post('/api/Helper/GetMultiLists', parameters, {'Content-Type': 'application/json'});
            const requestTwo =  axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'}); 
            const requestThree =  axios.post('/api/Helper/GetLists', parameters2, {'Content-Type': 'application/json'});
            const requestFour =  axios.post('/api/Helper/GetConst', parameters2, {'Content-Type': 'application/json'});
            const requestFive = axios.post('/api/DLLTemplates/GetDataImportTemplates', parameters3, {'Content-Type': 'application/json'});
            axios.all([requestOne, requestTwo, requestThree, requestFour,requestFive]).then(axios.spread((...responses) => {
                    this.bankList = responses[0].data.bank_list;
                    this.branchList = responses[1].data.branch;
                    this.currencyList = responses[1].data.currency;
                    this.bankDetailList = responses[2].data;
                    this.accountTypeList = responses[3].data;
                    this.dllTemplates = responses[4].data;
                    this.bankList.unshift({ id: '-1', text: this.$t('select_an_option')});
                    this.bankDetailList.unshift({ id: '-1', text: this.$t('select_an_option')});
                    this.dllTemplates.unshift({ id: null, name: this.$t('select_an_option')});

                    if (responses[1].data.account_setting.is_default == false) {
                        this.isViewAccountId = true;
                    }                
                    if (this.form.currency == null || this.form.currency == '' || this.form.currency == undefined) {
                        this.form.currency = this.$getUser().currency_code; 
                    }
                    this.$Progress.finish();
                })
            )
            .catch(errors => { 
                console.error(errors); 
                this.$Progress.finish(); 
            });  
        },
        async helpPageViewIcon()
        {
            const queryparameter = {
                session_id : this.$getUser().session_id,
                menu_selection : '/BankHelppage'
            };
            axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(!response.data.error){ 
                    this.iconView = response.data;
                }
            })
        }, 
        validateIban() {
            const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
            this.form.iban = this.form.iban.replace(/\s+/g, '').toUpperCase();
            if (this.form.iban.trim() === '') {
                this.ibanError = null;
                this.ibanErrorControl = false;
                this.maxLength = this.form.iban.length;
                return
            }
            if (!ibanRegex.test(this.form.iban)) {
                this.ibanError = "Enter a valid IBAN format.";
                this.ibanErrorControl = true;
                return;
            }
            const countryCode = this.form.iban.substring(0, 2);
            if (!this.ibanData[countryCode]) {
                this.ibanError = `An unsupported country code: ${countryCode}`;
                this.ibanErrorControl = true;
                return;
            }
            const expectedLength = this.ibanData[countryCode];
            if (this.form.iban.length !== expectedLength) {
                this.ibanError = `${countryCode} IBAN must be ${expectedLength} characters long.`;
                this.ibanErrorControl = true;
                this.maxLength = expectedLength;
                return;
            }
            if (this.form.iban.length == expectedLength) {
                this.form.iban = this.form.iban.slice(0, expectedLength); 
                this.ibanError = '';
                this.ibanErrorControl = false;
                this.maxLength = expectedLength; 
            }
            this.ibanError = null;
            this.ibanErrorControl = false;
        },
        saveData() {
            this.$checkSelect2Validation('poliform');
            if(!document.forms['poliform'].reportValidity()){
                return;
            }
            this.isProgressing = true;
            const params = { 
                id: this.form.id,
                name: this.form.name,
                company_id: this.form.company_id,
                account_type: this.form.account_type,
                account_id: this.form.account_id == '-1' ? null : this.form.account_id,
                qr_code: this.form.qr_code,
                notes: this.form.notes,
                account_number: this.form.account_number,
                bank_account_type_id: this.form.account_type_id == '' || this.form.account_type_id == null ? '1' : this.form.account_type_id,
                bank_bank_id: this.form.bank_bank_id == '-1' ? null : this.form.bank_bank_id,
                currency: this.form.currency == '-1' ? null : this.form.currency,
                bank_short_code: this.form.bank_short_code,
                branch_id: this.form.branch_id == '-1' ? null : this.form.branch_id,
                accounting_plan: this.form.accounting_plan,
                bank_detail_id: this.form.bank_detail_id == '-1' ? null : this.form.bank_detail_id,
                iban: this.form.iban,
                dll_template_id: this.form.dll_template_id
            };
            params.session_id = this.$getUser().session_id;
            const that = this;
            axios.post('api/CompanyAccounts/UpdateAccount', params, {'Content-Type': 'application/json'})
            .then((response) => {
            if (response.data != null && response.data.length == 36) {
                this.isShowWarning = false;
                this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
            }
            })
            .catch(() => {
                this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), 'error');
            })
            .finally(() => { 
                setTimeout(() => {
                    that.isProgressing = false;
                }, 500);
            }); 
        },
        deleteItem() {
            this.$swal
                .fire({
                title: this.$t('are_you_sure_you_want_to_delete_this_data'),
                confirmButtonColor: "#E53935",
                showDenyButton: false,
                showCancelButton: true,
                cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('yes'),
                icon: 'warning'
                })
                .then((result) => {
                if (result.isConfirmed) {
                    const params = {
                    session_id: this.$getUser().session_id,
                    id: this.form.id,
                    };
                    axios.post("api/CompanyAccounts/DeleteAccount", params, { "Content-Type": "application/json", })
                    .then((response) => { 
                        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                            this.$router.push({ name: "BankList" });
                        }
                    })
                    .catch(() => { 
                        this.$swal(this.$t('failed'), this.$t('data_could_not_be_deletedplease'), 'error');
                    }); 
                }
            });
        },
        activateDocumentsSection(){
            this.activeTab = 'Documents'; 
        },
        activateParametersSection(){
            this.activeTab = 'Parameters'; 
        },
        onSaveTemplate(){
            const params = {
                session_id: this.$getUser().session_id,
                name: this.modalForm.name,
                category_id: 6,
                description: this.modalForm.description,
                file_type_id: this.modalForm.file_type_id,
                module_type: 2,
                related_account_id: this.form.bank_bank_id == '-1' ? null : this.form.bank_bank_id
            };
            axios.post('api/DataImport/AddDataImportTemplate', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_import_template_saved_succesfully'), 'success');
                    this.isShowWarning = true;
                    this.form.dll_template_id = response.data;
                    this.$refs.closeDataImportModal.click();
                    this.onGetTemplateList();
                }
            })
        },
        onGetTemplateList() {
            const parameters = {
                session_id: this.$getUser().session_id,
                category: 0,
                module_type: 2,
                related_account_id: this.form.bank_bank_id == '-1' ? null : this.form.bank_bank_id
            };
            axios.post('/api/DLLTemplates/GetDataImportTemplates', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.dllTemplates = response.data;
                    this.dllTemplates.unshift({ id: '-1', text: this.$t('select_an_option')});
                }
            })
            .catch((error) => {
            console.error(error);
            });
        },
        onDeleteDesign() {
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_delete_this_data'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('delete'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const parameters = {
                        session_id: this.$getUser().session_id,
                        id: this.form.dll_template_id
                    };  
                    axios.post('/api/DataImport/DeleteDataImportTemplate', parameters, {'Content-Type': 'application/json'})
                    .then((response) => {
                        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                            this.onGetTemplateList();
                            this.form.dll_template_id = null;
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                }
            });
        },
        onOpenParametersModal(){
            this.isShow.ParameterModal = true;
            this.$setSessionStorage("template_record_id", this.form.dll_template_id);
            if (this.$refs.DataImportParametersModal) {
                this.$refs.DataImportParametersModal.getData();
            }
        },
        onOpenDesignerModal(){
            this.isShow.DesignerModal = true;
            this.$setSessionStorage("template_record_id", this.form.dll_template_id);
            if (this.$refs.DataImportDesingerModal) {
                this.$refs.DataImportDesingerModal.onGetTemplate();
            }
        },
        onOpenAddModal() {
            this.modalForm = {
                name: null,
                description: null,
                file_type_id: 0
            };
        },        
        getTemplateData(){
            this.$setSessionStorage("template_record_id", this.form.dll_template_id);            
            this.isShow.EditModal = true;
            const parameters = {
                session_id: this.$getUser().session_id,
                id: this.form.dll_template_id,
                template_id: this.form.dll_template_id
            };  
            const requestOne =  axios.post('/api/DataImport/GetDataImportTemplateById', parameters, {'Content-Type': 'application/json'});
            const requestTwo =  axios.post('/api/DataImport/GetWorksheetParameters', parameters, {'Content-Type': 'application/json'});        
            axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
                this.editForm = responses[0].data;
                this.worksheets = responses[1].data; 
            }))
            .catch(errors => { 
                console.error(errors); 
            });
        },
        onFileChange(event) {
            const formData = new FormData();
            formData.append('file', event.target.files[0]);
            formData.append('record_id',  this.$getSessionStorage('template_record_id'));
            formData.append('file_type',  this.editForm.file_type_id);
            this.fileName = event.target.files[0].name;
            fetch('/api/DataImport/GetWorksheets', {
                method: 'POST',
                body: formData,
                headers: {}
            }).then(response => response.json())
                .then(data => { 
                    data.forEach((item) => {
                        this.sheetNames.push({
                            name: item,
                            description: null
                        });
                    });
                });
        },
        onUpdateTemplate(){
            const params = {
                id: this.editForm.id,
                session_id: this.$getUser().session_id,
                name: this.editForm.name,
                category_id: this.editForm.category_id,
                description: this.editForm.description,
                file_type_id: this.editForm.file_type_id,
                related_account_id: this.form.bank_bank_id == '-1' ? null : this.form.bank_bank_id
            };
            axios.post('api/DataImport/UpdateDataImportTemplate', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){      
                    this.$swal(this.$t('success'), this.$t('data_import_template_saved_succesfully'), 'success');
                    this.$refs.closeDataImportEditModal.click();
                }
            })
        },
        onAddWorksheet(item){
            var virtualName = "";
            //Eğer bu isimde bir worksheet varsa _{0} ekleyerek devam et
            var i = 0;
            this.worksheets.forEach(element => {
                if(element.name.includes(item.name)){
                    i++;
                }
            });
            if(i > 0){
                virtualName = item.name + "_" + i;
            }
            else{
                virtualName = item.name;
            }

            const params = {
                session_id: this.$getUser().session_id,
                template_id: this.$getSessionStorage('template_record_id'),
                name: item.name,
                virtual_name: virtualName,
                description: item.description
            };
            axios.post('api/DataImport/AddWorksheetParameter', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){      
                    this.onGetWorksheetParametersFromDB();
                }
            });
        },
        onUpdateOrder(item, operator) {
            let columnOrder = item.column_order;
            if(operator == 'plus') columnOrder++;
            if(operator == 'minus') columnOrder--;
            const parameters = {
                session_id: this.$getUser().session_id,
                column_order: columnOrder,
                template_id: item.template_id,
                id: item.id
            };  
            axios.post('/api/DataImport/UpdateWorksheetOrder', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.worksheets = response.data;
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        onRemoveWorksheet(item){
            const params = {
                session_id: this.$getUser().session_id,
                id: item.id
            };
            axios.post('api/DataImport/RemoveWorksheetParameter', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.onGetWorksheetParametersFromDB();
                }
            }); 
        },
        onGetWorksheetParametersFromDB(){
            const params = {
                session_id: this.$getUser().session_id,
                template_id: this.$getSessionStorage('template_record_id')
            };
            axios.post('api/DataImport/GetWorksheetParameters', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.worksheets = response.data;
                }
            });  
        }
    },
    created() {
        this.helpPageViewIcon();
        this.getData();
    },
};
</script>
<style>
    .is-invalid {
        border: 1px solid red;
    }
    .error-message {
        color: red;
        font-size: 0.9em;
    }
</style>